import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSelfExclusion = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M32 28.333a7.333 7.333 0 1 0 0-14.666 7.333 7.333 0 0 0 0 14.666"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M37.958 21a5.958 5.958 0 1 0-11.916 0 5.958 5.958 0 0 0 11.916 0m2.75 0a8.708 8.708 0 1 1-17.416 0 8.708 8.708 0 0 1 17.416 0"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M37.5 34.433a25 25 0 0 0-5.5-.6c-8.1 0-14.667 3.694-14.667 8.25 0 4.557 0 8.25 14.667 8.25 10.427 0 13.441-1.866 14.313-4.583"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M15.958 42.083c0-2.995 2.144-5.427 4.997-7.032 2.896-1.629 6.804-2.593 11.045-2.593 2.044 0 4.002.224 5.804.634l-.609 2.682A23.5 23.5 0 0 0 32 35.208c-3.859 0-7.284.883-9.697 2.24-2.456 1.382-3.595 3.075-3.595 4.635 0 2.398.074 3.748 1.327 4.768.679.553 1.814 1.093 3.758 1.486 1.938.392 4.587.621 8.207.621 5.169 0 8.33-.468 10.26-1.187 1.835-.683 2.456-1.546 2.743-2.442l2.618.842c-.585 1.82-1.907 3.25-4.403 4.179-2.4.893-5.96 1.358-11.218 1.358-3.714 0-6.564-.232-8.751-.675-2.182-.441-3.797-1.11-4.95-2.05-2.415-1.965-2.34-4.74-2.34-6.9"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M37.814 44.519a7.333 7.333 0 1 0 10.371-10.371m-10.37 10.37a7.333 7.333 0 0 1 10.371-10.371M37.813 44.52l10.371-10.371z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M48.958 39.333a5.9 5.9 0 0 0-.888-3.127l-8.198 8.198a5.958 5.958 0 0 0 9.086-5.07m-11.916 0c0 1.148.324 2.217.886 3.126l8.198-8.198a5.958 5.958 0 0 0-9.084 5.072m14.666 0a8.708 8.708 0 1 1-17.416 0 8.708 8.708 0 0 1 17.416 0"
      />
    </svg>
  );
};
export default SvgSelfExclusion;
